import React from 'react';
import { Box } from '@mui/material';
import SdVideoOnDemandApi from './sd-video-on-demand-api/SdVideoOnDemandApi';
import SdVideoPlaybackApi from './sd-video-playback-api/SdVideoPlaybackApi';
import SdVideoDownloadApi from './sd-video-download-api/SdVideoDownloadApi';
import CameraDetailsApi from './camera-details-api/CameraDetailsApi';
import VehicleListApi from './vehicle-list-api/VehicleListApi';

const SdCardVehicleApis: React.FC = () => {
    return (
        <Box>
            <SdVideoOnDemandApi />
            <SdVideoPlaybackApi />
            <SdVideoDownloadApi />
            <CameraDetailsApi />
            <VehicleListApi />
        </Box>
    );
};

export default SdCardVehicleApis;
